/**
 * micGuard — the microphone is released the moment the page is not in front.
 *
 * On a phone, a tab that is backgrounded, a locked screen, or a switch to
 * another app does NOT unload the page, so a MediaStream, a MediaRecorder or
 * a SpeechRecognition that nobody stopped keeps the mic open for hours —
 * David's car reported a "phone call" in progress the day after a session
 * (Oct 16). Every holder of the mic registers a release function here; it
 * runs on visibilitychange→hidden, pagehide and beforeunload. Returns the
 * unregister function.
 */
const holders = new Set();
let wired = false;

function releaseAll() {
  for (const fn of Array.from(holders)) {
    try { fn(); } catch { /* releasing is best-effort */ }
  }
}

function wire() {
  if (wired || typeof window === "undefined") return;
  wired = true;
  document.addEventListener("visibilitychange", () => { if (document.visibilityState === "hidden") releaseAll(); });
  window.addEventListener("pagehide", releaseAll);
  window.addEventListener("beforeunload", releaseAll);
}

export function holdMic(release) {
  wire();
  holders.add(release);
  return () => holders.delete(release);
}

/** Stop every track of a stream — the only thing that turns the mic light off. */
export function stopStream(stream) {
  try { stream?.getTracks().forEach(t => t.stop()); } catch { /* fine */ }
}

/** For tests. */
export function _releaseAllForTests() { releaseAll(); }
